import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class FreeThrowDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"LANCER FRANC"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "LANCER FRANC",
            player: event.detail?.player,
            isSucceed: true
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player"].includes(key)){
            let commentaire = "Lancer franc"

            const buteurPlayer = getPlayer(this.buteur, match)
            const team = getTeam(this.team, match)

            if(this.buteur){
                if(buteurPlayer){
                    commentaire += ' de '+ buteurPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            this.text = commentaire
        }
    }
}